var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"icon":""},on:{"click":function($event){$event.stopPropagation();return _vm.toggleFavourite($event)}}},[_c('v-icon',{attrs:{"color":_vm.favColor}},[_vm._v(_vm._s(_vm.favIcon))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }